let cache = {};

/**
 * @param voiceId
 * @param text
 * @param audio
 */
export const cacheAudio = (voiceId, text, audio) => {
  if (!cache[voiceId]) {
    cache[voiceId] = {};
  }

  cache[voiceId][text] = audio;
};

export const getAudio = (voiceId, text) => {
  const audioObj = cache[voiceId];

  if (!audioObj) {
    return null;
  }

  return audioObj[text] || null;
};

export const clearCache = () => {
  cache = {};
};
